import { useLanguage } from '../../../hooks/useLanguage';

export default function CTANew() {
  const { language } = useLanguage();

  const content = {
    de: {
      label: 'Jetzt starten',
      headline: 'Bereit, Ihre Prozesse zu automatisieren?',
      subtext: 'Vereinbaren Sie eine kostenlose Demo und sehen Sie TELIQone in Aktion — angepasst an Ihre Use Cases.',
      cta: 'Kostenlose Demo buchen'
    },
    en: {
      label: 'Get Started',
      headline: 'Ready to automate your processes?',
      subtext: 'Schedule a free demo and see TELIQone in action — tailored to your use cases.',
      cta: 'Book Free Demo'
    }
  };

  const t = content[language];

  return (
    <section id="cta" className="relative py-20 sm:py-28 bg-black">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <div className="bg-gradient-to-br from-blue-600/20 to-blue-800/20 border border-blue-500/30 rounded-2xl p-8 sm:p-12 fade-in-section">
          <div className="inline-block px-3 py-1 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
            <span className="text-blue-400 text-xs font-semibold uppercase tracking-widest">{t.label}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
            {t.headline}
          </h2>
          <p className="text-base sm:text-lg text-white/60 mb-8 leading-relaxed">
            {t.subtext}
          </p>
          <a
            href="mailto:info@teliq.one"
            className="inline-block px-8 py-4 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-500 transition-all hover:shadow-lg hover:shadow-blue-600/30 whitespace-nowrap cursor-pointer text-sm"
          >
            {t.cta}
          </a>
        </div>
      </div>
    </section>
  );
}